// extracted by mini-css-extract-plugin
export default {"sidebarExpandedWidth":"200px","sidebarCollapsedWidth":"80px","neon-card-grid":"neon-card-grid","neon-resizable-card":"neon-resizable-card","theme-browser":"theme-browser"};